export default class DFP {

    constructor(options) {
        this.options = options;
    }


    Load() {
        //const options = this.options;
        var googletag = window.googletag || {};
        googletag.cmd = googletag.cmd || [];

        window.DFP = {};
        window.DFP.ads = {};
        window.DFP.ads.bannersOcultar = "";
        window.DFP.ads.deviceResolution = this.options.resolution;

        googletag.cmd.push(() => {
            this.options.slots.forEach((item, index) => {
                const sectionId = item.section || this.options.defaultSectionId;
                const id = `/${this.options.id}/${this.options.name}/${sectionId}/${item.name + this.options.resolution}`;
                
                const slot = googletag.defineSlot(id, item.size, item.name + this.options.resolution).addService(googletag.pubads());
                if (item.build) {
                    var mapping = googletag.sizeMapping().
                        addSize([0, 0], [[920, 170], [970, 90], [728, 90]]).
                        addSize([1260, 100], [1260, 170]).
                        build();
                    slot.defineSizeMapping(mapping);
                }
            });

            if (this.options.collapseDivs) googletag.pubads().collapseEmptyDivs();

            googletag.pubads().setTargeting('tags', this.getKeywords());
            googletag.pubads().setTargeting('seccion', this.options.seccion);
            googletag.pubads().setTargeting('sitio', this.options.sitio);

            googletag.pubads().enableSingleRequest();
            googletag.enableServices();
        });
        googletag && googletag.pubads().refresh();

    }


    getKeywords() {
        const path = document.location.pathname;
        let section = this.options.defaultKeyword;
        Object.keys(this.options.keywords).forEach((item, index) => {
            const regEx = new RegExp(this.options.keywords[item]);
            if (regEx.test(path)) {
                section = item;
            }

        });
        return section;
    }
}


// WEBPACK FOOTER //
// ./Statics/scripts/Modules/DFP/DFP.js